import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Checkbox } from "@/components/ui/checkbox";
import { properties } from "@/data/site";
import { todayISO } from "@/lib/booking";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CustomRequest() {
  const [f, setF] = useState({ firstName: "", lastName: "", email: "", phone: "", property: "", checkin: "", checkout: "", guests: 2, message: "", privacy: false, website: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e?.target ? e.target.value : e });

  const submit = async (e) => {
    e.preventDefault();
    if (!f.firstName || !f.lastName || !f.email || !f.message) { toast.error("Compila i campi obbligatori."); return; }
    if (!f.privacy) { toast.error("Il consenso privacy è obbligatorio."); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, {
        firstName: f.firstName, lastName: f.lastName, email: f.email, phone: f.phone,
        property: f.property, checkin: f.checkin, checkout: f.checkout, guests: Number(f.guests),
        message: f.message, privacyConsent: f.privacy, website: f.website,
      });
      toast.success("Richiesta inviata correttamente. Ti risponderemo al più presto.");
      setF({ firstName: "", lastName: "", email: "", phone: "", property: "", checkin: "", checkout: "", guests: 2, message: "", privacy: false, website: "" });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore durante l’invio. Riprova.");
    } finally { setLoading(false); }
  };

  const inp = "w-full bg-white border border-brand-ivory rounded-xl px-4 py-3 text-sm outline-none focus:border-brand-olive transition-colors";
  return (
    <section className="py-20 md:py-24 bg-brand-ivory/40">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <h3 className="font-heading text-3xl md:text-4xl text-brand-black font-light">Non trovi la soluzione che cerchi?</h3>
        <p className="mt-3 text-brand-brown">Inviaci una richiesta personalizzata: ti aiuteremo a individuare la struttura più adatta.</p>
        <form data-testid="custom-request-form" onSubmit={submit} className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4">
          <input required placeholder="Nome *" value={f.firstName} onChange={set("firstName")} data-testid="cr-firstname" className={inp} />
          <input required placeholder="Cognome *" value={f.lastName} onChange={set("lastName")} data-testid="cr-lastname" className={inp} />
          <input required type="email" placeholder="E-mail *" value={f.email} onChange={set("email")} data-testid="cr-email" className={inp} />
          <input placeholder="Telefono" value={f.phone} onChange={set("phone")} className={inp} />
          <select value={f.property} onChange={set("property")} className={`${inp} md:col-span-2`} data-testid="cr-property">
            <option value="">Struttura di interesse (facoltativo)</option>
            {properties.map((p) => <option key={p.id} value={p.name}>{p.name}</option>)}
          </select>
          <label className="text-sm text-brand-brown">Check-in<input type="date" min={todayISO()} value={f.checkin} onChange={set("checkin")} className={`${inp} mt-1`} /></label>
          <label className="text-sm text-brand-brown">Check-out<input type="date" min={f.checkin || todayISO()} value={f.checkout} onChange={set("checkout")} className={`${inp} mt-1`} /></label>
          <input type="number" min="1" max="12" placeholder="Numero ospiti" value={f.guests} onChange={set("guests")} className={`${inp} md:col-span-2`} />
          <textarea required placeholder="Il tuo messaggio *" rows={4} value={f.message} onChange={set("message")} data-testid="cr-message" className={`${inp} md:col-span-2 resize-none`} />
          <input tabIndex={-1} autoComplete="off" value={f.website} onChange={set("website")} className="hidden" aria-hidden="true" />
          <label className="flex items-start gap-2 text-sm text-brand-brown md:col-span-2">
            <Checkbox checked={f.privacy} onCheckedChange={(v) => setF({ ...f, privacy: !!v })} data-testid="cr-privacy" />
            <span>Ho letto e accetto l’<a href="/privacy" className="underline text-brand-olive">informativa privacy</a>. *</span>
          </label>
          <button type="submit" disabled={loading} data-testid="cr-submit" className="md:col-span-2 justify-self-start bg-brand-olive text-white hover:bg-brand-black transition-colors rounded-full px-9 py-3.5 font-medium disabled:opacity-60">
            {loading ? "Invio in corso..." : "Invia la richiesta"}
          </button>
        </form>
      </div>
    </section>
  );
}
